<template>
  <v-row>
    <v-col cols="12" md="6" class="pb-0">
      <v-text-field :background-color="inputsBackground"
                    color="kbDarkBlueText"
                    :rules="[rules.isANumber, v => rules.minimumAmount(v, 0)]"
                    solo
                    type="number"
                    validate-on-blur
                    v-model="localTime" />
    </v-col>

    <v-col cols="12" md="6" class="pb-0">
      <v-select :background-color="inputsBackground"
                color="kbDarkBlueText"
                :items="timeMeasureUnitItems"
                item-text="name"
                item-value="value"
                :rules="[rules.required]"
                solo
                validate-on-blur
                :value="timeUnits"
                @change="onTimeUnitsChange" />
    </v-col>
  </v-row>
</template>

<script>
import rules from '@/libs/rules'
export default {
  computed: {
    localTime: {
      get () {
        return this.time
      },
      set (value) {
        if (rules.isANumber(value) !== true) return
        // const timeInMinutes = this.setTimeInMinutes(value)
        this.$emit('onTimeChange', value)
      }
    }
  },
  data () {
    return {
      rules,
      timeMeasureUnitItems: [
        { name: this.$t('general.days'), value: 'days' },
        { name: this.$t('general.hours'), value: 'hours' },
        { name: this.$t('general.minutes'), value: 'minutes' }
      ]
    }
  },
  methods: {
    onTimeUnitsChange (timeUnits) {
      this.$emit('onTimeUnitsChange', timeUnits)
    },
    setTimeInMinutes (timeToTransform) {
      let timeToMinutesConverter = 1
      const time = parseInt(timeToTransform)
      if (this.timeMeasureUnit === 'days') {
        timeToMinutesConverter = 1440
      } else if (this.timeMeasureUnit === 'hours') {
        timeToMinutesConverter = 60
      }
      return time * timeToMinutesConverter
    }
  },
  props: {
    inputsBackground: {
      type: String,
      default: 'kbWhite'
    },
    time: {
      type: [String, Number],
      default: 0
    },
    timeUnits: {
      type: String,
      required: true
    }
  }
}
</script>
